'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Dependencies
 *
 * TODO
 * - switch between Node.js webcrypto package and browser implementation
 */
var base64url = require('base64url');
var supportedAlgorithms = require('./algorithms');

var _require = require('./errors'),
    NotSupportedError = _require.NotSupportedError,
    DataError = _require.DataError;

var crypto = require('@trust/webcrypto');

/**
 * JWA
 * https://tools.ietf.org/html/rfc7518
 */

var JWA = function () {
  function JWA() {
    _classCallCheck(this, JWA);
  }

  _createClass(JWA, null, [{
    key: 'sign',


    /**
     * Sign
     *
     * @description
     * Create a digital signature.
     *
     * @param {string} alg
     * @param {CryptoKey} key
     * @param {string|Buffer} data
     *
     * @return {Promise}
     */
    value: function sign(alg, key, data) {
      // normalize the algorithm
      var normalizedAlgorithm = supportedAlgorithms.normalize('sign', alg);

      // validate algorithm is supported
      if (normalizedAlgorithm instanceof Error) {
        return Promise.reject(new NotSupportedError(alg));
      }

      // sign the data
      return normalizedAlgorithm.sign(key, data);
    }

    /**
     * Verify
     *
     * @description
     * Verify a digital signature.
     *
     * @param {string} alg
     * @param {CryptoKey} key
     * @param {string|Buffer} signature
     * @param {string|Buffer} data
     *
     * @return {Promise}
     */

  }, {
    key: 'verify',
    value: function verify(alg, key, signature, data) {
      // normalize the algorithm
      var normalizedAlgorithm = supportedAlgorithms.normalize('verify', alg);

      // validate algorithm is supported
      if (normalizedAlgorithm instanceof Error) {
        return Promise.reject(new NotSupportedError(alg));
      }

      // verify the signature
      return normalizedAlgorithm.verify(key, signature, data);
    }

    /**
     * Encrypt
     *
     * @description
     * Encrypt data and associated additional authentication data.
     *
     * @param {string} alg
     * @param {CryptoKey} key
     * @param {string|Buffer} data
     * @param {string|Buffer} aad
     *
     * @return {Promise}
     */

  }, {
    key: 'encrypt',
    value: function encrypt(alg, key, data, aad) {
      // normalize the algorithm
      var normalizedAlgorithm = supportedAlgorithms.normalize('encrypt', alg);

      // validate algorithm is supported
      if (normalizedAlgorithm instanceof Error) {
        return Promise.reject(new NotSupportedError(alg));
      }

      // encrypt the data
      return normalizedAlgorithm.encrypt(key, data, aad);
    }

    /**
     * Decrypt
     *
     * @description
     * Decrypt the given data (authenticated with the aad) encrypted with iv,
     * checking for integrity using the tag provided.
     *
     * @param {string} alg
     * @param {CryptoKey} key
     * @param {string|Buffer} data
     * @param {string|Buffer} iv
     * @param {string|Buffer} tag
     * @param {string|Buffer} aad
     *
     * @return {Promise}
     */

  }, {
    key: 'decrypt',
    value: function decrypt(alg, key, data, iv, tag, aad) {
      // normalize the algorithm
      var normalizedAlgorithm = supportedAlgorithms.normalize('decrypt', alg);

      // validate algorithm is supported
      if (normalizedAlgorithm instanceof Error) {
        return Promise.reject(new NotSupportedError(alg));
      }

      // decrypt the data and recover the contents
      return normalizedAlgorithm.decrypt(key, data, iv, tag, aad);
    }

    /**
     * encryptKey
     *
     * @description
     * Encrypt or wrap key using the specifed algorithm and the wrappingKey.
     *
     * @param {string} alg
     * @param {CryptoKey} key
     * @param {CryptoKey} wrappingKey
     *
     * @returns {Promise}
     */

  }, {
    key: 'encryptKey',
    value: function encryptKey(alg, key, wrappingKey) {
      // normalize the algorithm
      var normalizedAlgorithm = supportedAlgorithms.normalize('encryptKey', alg);

      // validate algorithm is supported
      if (normalizedAlgorithm instanceof Error) {
        return Promise.reject(new NotSupportedError(alg));
      }

      return normalizedAlgorithm.encryptKey(key, wrappingKey);
    }

    /**
     * decryptKey
     *
     * @description
     * Decrypt or unwrap a wrappedKey.
     *
     * @param {string} alg
     * @param {string|Buffer} wrappedKey
     * @param {CryptoKey} unwrappingKey
     * @param {string} unwrappedKeyAlg
     *
     * @returns {Promise}
     */

  }, {
    key: 'decryptKey',
    value: function decryptKey(alg, wrappedKey, unwrappingKey, unwrappedKeyAlg) {
      // normalize the algorithm
      var normalizedAlgorithm = supportedAlgorithms.normalize('decryptKey', alg);

      // validate algorithm is supported
      if (normalizedAlgorithm instanceof Error) {
        return Promise.reject(new NotSupportedError(alg));
      }

      return normalizedAlgorithm.wrapKey(wrappedKey, unwrappingKey, unwrappedKeyAlg);
    }

    /**
     * agreeKey
     *
     * @description
     * Agree on a new key and optionally wrap it with a provided wrappingKey.
     *
     * @param {string} alg
     * @param {CryptoKey} wrappingKey
     *
     * @returns {Promise}
     */

  }, {
    key: 'agreeKey',
    value: function agreeKey(alg, wrappingKey) {
      // normalize the algorithm
      var normalizedAlgorithm = supportedAlgorithms.normalize('agreeKey', alg);

      // validate algorithm is supported
      if (normalizedAlgorithm instanceof Error) {
        return Promise.reject(new NotSupportedError(alg));
      }

      return normalizedAlgorithm.agreeKey(wrappingKey);
    }

    /**
     * Generate Key
     *
     * @description
     * Generate key / key pair based on the specified attributes.
     *
     * @param {string} alg
     * @param {Object} options
     *
     * @return {Promise}
     */

  }, {
    key: 'generateKey',
    value: function generateKey(alg) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      // normalize the algorithm
      var normalizedAlgorithm = supportedAlgorithms.normalize('generateKey', alg);

      // validate algorithm is supported
      if (normalizedAlgorithm instanceof Error) {
        return Promise.reject(new NotSupportedError(alg));
      }

      var key_ops = options.key_ops,
          _options$extractable = options.extractable,
          extractable = _options$extractable === undefined ? true : _options$extractable;


      if (!key_ops || !Array.isArray(key_ops)) {
        return Promise.reject(new DataError('Invalid key_ops'));
      }

      return normalizedAlgorithm.generateKey(extractable, key_ops, options);
    }

    /**
     * Import
     *
     * @description
     * Import a key in JWK format.
     *
     * @param {CryptoKey} key
     *
     * @return {Promise}
     */

  }, {
    key: 'importKey',
    value: function importKey(key) {
      // map the JWA alg name to the corresponding object
      var normalizedAlgorithm = supportedAlgorithms.normalize('importKey', key.alg);

      // validate algorithm is supported
      if (normalizedAlgorithm instanceof Error) {
        return Promise.reject(new NotSupportedError(key.alg));
      }

      return normalizedAlgorithm.importKey(key);
    }

    /**
     * Export key
     *
     * @description
     * Export the key in the specified format.
     *
     * @param {string} format
     * @param {CryptoKey} key
     *
     * @return {Promise}
     */

  }, {
    key: 'exportKey',
    value: function exportKey(format, key) {
      return crypto.subtle.exportKey(format, key);
    }
  }]);

  return JWA;
}();

/**
 * Export
 */


module.exports = JWA;


//////////////////
// WEBPACK FOOTER
// ./~/@trust/jwa/lib/JWA.js
// module id = 27
// module chunks = 0